import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';

interface SettingsProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const PRO_SETTINGS_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/pro_settings.png',
  isEnvDependent: false,
});

const ANNUAL_SETTINGS_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/annual_settings.png',
  isEnvDependent: false,
});

const Settings = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps = 5,
}: SettingsProps) => {
  const mediaSrc = isProSubscriber ? PRO_SETTINGS_IMAGE_SRC : ANNUAL_SETTINGS_IMAGE_SRC;

  return (
    <MobileStepWithMedia
      description="Complete your profile, update account and Deep Research settings to tailor your Pro experience."
      handleClose={handleClose}
      handleNext={handleNext}
      isProSubscriber={isProSubscriber}
      media={
        <img
          src={mediaSrc}
          alt="Settings menu example"
          className="h-full w-full object-cover object-top"
        />
      }
      showCloseButton={true}
      step={step}
      title="Settings"
      totalSteps={totalSteps}
    />
  );
};

export default Settings;
